import React from 'react'
import { XCircleIcon } from '@heroicons/react/24/solid'
import EtUpdateUserActionComp from '@/features/userActions/EtUpdateUserActionComp'

const EtModalUpdateUserAction = ({
  isOpen,
  onClose,
  actionId = null,
  actionData = {},
  refetchUserActions = () => {}
}) => {

  // First Created - 04 Apr 2025
  // Author - Atul Pandey
  // Inherited from EtModalCreateUserAction

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-start font-poppins overflow-y-auto p-4" style={{ zIndex: 9999 }}>
      <div className="bg-black p-3 rounded-lg shadow-lg shadow-black relative w-full max-w-5xl">
        
        {/* Close Button */}
        <div
          className="absolute top-1 right-1 m-1 font-bold rounded-full cursor-pointer h-7 w-7 flex justify-center items-center"
          onClick={onClose}
        >
          <XCircleIcon className='text-orange-600 rounded-full hover:text-red-600 h-7 w-7' />
        </div>

        {/* Main Component */}
        <EtUpdateUserActionComp
          id={actionId}
          userAction={actionData}
          refetchUserActions={refetchUserActions}
          onClose={onClose}
        />
      </div>
    </div>
  )
}

export default EtModalUpdateUserAction